import { render, staticRenderFns } from "./VoucherSlash.vue?vue&type=template&id=24904010&"
import script from "./VoucherSlash.vue?vue&type=script&lang=js&"
export * from "./VoucherSlash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports